// How a jump along a link of a note or a template finds and shows the end it
// lands on.

// A value inside a double-quoted attribute selector.
export const quoteAttribute = (value: string) =>
  value.replace(/["\\]/g, '\\$&');

const LINK_FLASH = 'data-link-flash';

// An option of a template's choice as the editor and the read template
// render it.
export const findLinkOption = (
  root: ParentNode | null | undefined,
  blockId: string,
  value: string,
) =>
  root?.querySelector<HTMLElement>(
    `[data-link-block="${quoteAttribute(blockId)}"][data-link-value="${quoteAttribute(value)}"]`,
  ) ?? null;

// The first target is scrolled into the middle of the view, and every target
// is lit for a moment by its `data-link-flash` animation.
export const revealLinkTarget = (
  targets: (HTMLElement | null | undefined)[],
) => {
  const shown = targets.filter((target): target is HTMLElement => !!target);
  shown[0]?.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
  shown.forEach((target) => {
    const settle = (event: AnimationEvent) => {
      if (event.target === target) {
        target.removeAttribute(LINK_FLASH);
        target.removeEventListener('animationend', settle);
      }
    };
    target.removeAttribute(LINK_FLASH);
    // Laid out without the mark first, a target lit again starts over.
    void target.offsetWidth;
    target.setAttribute(LINK_FLASH, '');
    target.addEventListener('animationend', settle);
  });
};
